import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/auth'

// "/" is not a real page - it only decides where you belong.
const DASHBOARD_BY_ROLE = {
  1: '/admin/dashboard',
  2: '/cashier/dashboard',
  3: '/user/dashboard',
}

const HomePage = () => {
  const [auth] = useAuth()

  // auth is read from localStorage synchronously on the first render, so this
  // never flashes the login page for someone who is already signed in.
  if (!auth?.user) {
    return <Navigate to='/login' replace />
  }

  return (
    <Navigate
      to={DASHBOARD_BY_ROLE[auth.user.role] || '/cashier/dashboard'}
      replace
    />
  )
}

export default HomePage
